import type { ItemsDto } from '@/modules/common/dto/items.dto.ts';
import type { ManagerDto } from '@/modules/counterparty/dto/manager.dto.ts';
import type { Manager } from '@/modules/counterparty/types/manager.type.ts';

export class ManagerAdapter {
  private static map(response: ManagerDto): Manager {
    return {
      id: response.LOGIN_ID,
      name: response.ФИО,
    };
  }

  static mapList(response: ItemsDto<ManagerDto>) {
    return response.items.map(ManagerAdapter.map);
  }
}
